module.exports = __webpack_public_path__ + "static/media/Chapter 2 Slide 1.1a5dba56.jpg";